'use client'

import FortoLogo from '@public/images/logos/forto-white.png'
import Image from 'next/image'

import CustomerQuote from '@/components/CustomerQuote'

const FortoCustomerQuoteAbout = () => {
    return (
        <CustomerQuote
            light={true}
            backgroundImageSrc={'/images/customer-quotes/forto-quote-desktop.png'}
            mobileBackgroundImageSrc={'/images/customer-quotes/forto-quote-mobile.png'}
            logo={<Image src={FortoLogo} alt={`Forto Logo`} height={24} width={98.12} />}
            title={
                <>
                    We assessed several providers and found that Lune is truly challenging the
                    status quo.
                </>
            }
            avatar={{
                title: 'Nina Göntgen-Voss',
                subtitle: 'Director of Sustainability at Forto',
                imageSrc: '/images/avatars/forto-customer-quote-avatar.png',
            }}
        />
    )
}

export default FortoCustomerQuoteAbout
